import React from "react";
import Avatar from "../../components/common/Avatar";
import flightBlack from "../../assets/images/flightBlack.png";
import shipGreen from "../../assets/images/shipGreen.png";
import vanGreen from "../../assets/images/vanGreen.png";

const modeImage = (id) => {
    switch (id) {
        case 1:
            return vanGreen;
        case 2:
            return flightBlack;
        case 3:
            return shipGreen;
        default:
            return "";
    }
};

const DeliveryTermsWorklistRow = ({
    item,
    rowIndex,
    menuRights,
    handleView,
    handleEdit,
    handleDelete,
}) => {
    const rowParity = rowIndex % 2 === 0 ? "row-even" : "row-odd";
    const canOpenView = menuRights?.canView === true;
    const canOpenEdit = menuRights?.canEdit === true;
    const isRowClickable = canOpenEdit || canOpenView;

    return (
        <div className={`card quote-project-row ${rowParity}`}>
            <div className="card-body">
                <div className="quote-project-grid">
                    <div
                        className="project-cell"
                        onClick={
                            canOpenEdit
                                ? () => handleEdit(item)
                                : canOpenView
                                    ? () => handleView(item)
                                    : undefined
                        }
                        style={{ cursor: isRowClickable ? "pointer" : "default" }}
                    >
                        <Avatar preName={item?.deliveryDescription} />
                        <div className="project-copy">
                            <h4>{item?.deliveryDescription}</h4>
                            <span>{item?.abbreviation}</span>
                        </div>
                    </div>

                    <div className="description-cell" title={item?.termsTooltip}>
                        {item?.termsTooltip}
                    </div>

                    <div className="mode-cell">
                        {item?.modeofTransports
                            ?.split(",")
                            .map((modeId) => parseInt(modeId, 10))
                            .sort((a, b) => a - b)
                            .map((id) => (
                                <img key={id} src={modeImage(id)} alt={`Mode ${id}`} width="16" />
                            ))}
                    </div>

                    <div>
                        <span
                            className={`delivery-status-pill ${item?.isActive ? "active" : "inactive"
                                }`}
                        >
                            {item?.isActive ? "Active" : "Inactive"}
                        </span>
                    </div>

                    <div className="open-cell">
                        {(menuRights?.canView === true || menuRights?.canEdit === true || menuRights?.canDelete === true) && (
                            <div className="dropdown dropleft text-align">
                                <i
                                    className="fas fa-ellipsis-v"
                                    id={`deliveryTermsDropdown-${item?.id}`}
                                    data-toggle="dropdown"
                                    aria-haspopup="false"
                                    aria-expanded="false"
                                ></i>
                                <div
                                    className="dropdown-menu p-0"
                                    aria-labelledby={`deliveryTermsDropdown-${item?.id}`}
                                >
                                    <ul>
                                        {menuRights?.canEdit === true && (
                                            <li onClick={() => handleEdit(item)}>
                                                <i className="far fa-edit"></i> Edit
                                            </li>
                                        )}
                                        {menuRights?.canDelete === true && (
                                            <li onClick={() => handleDelete(item)}>
                                                <i className="far fa-trash-alt"></i> Delete
                                            </li>
                                        )}
                                        {menuRights?.canView === true && (
                                            <li onClick={() => handleView(item)}>
                                                <i className="far fa-eye"></i> View
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(DeliveryTermsWorklistRow);